/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PaymentInitiationPaginatedProperty =
  typeof PaymentInitiationPaginatedProperty[keyof typeof PaymentInitiationPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentInitiationPaginatedProperty = {
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT',
} as const;
